import React from 'react'
import { Carousel } from 'react-bootstrap'
import DATA from './clientsData'



class Clients extends React.Component {
  get splitClientsData () {
    const clients=[]
    let items
    let start=0
    let i=1
    for (i=1; i<=(DATA.length/12); i++) {
      items = DATA.slice(start, 12*i).map(client => (
        <div key={client.client} className="col-md-4 col-lg-4 col-sm-6">
          <div className="media testimonial">
            <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
              <img
                className="img-responsive center-block"
                src={client.img}
                alt={client.client}
          />
            </div>
              <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                <h3 style={{ fontSize: 20.5 }} className="media-heading">{client.client}</h3>
                  <blockquote>
                    <footer>{client.location}</footer>
                  </blockquote>
              </div>
          </div>
        </div>
      )
      )
      start=12*i
      clients[i]=items
    }
    if (DATA.length>start) {
      items = DATA.slice(start, DATA.length).map(client => (
        <div key={client.client} className="col-md-4 col-lg-4 col-sm-6">
          <div className="media testimonial">
            <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
              <img
                className="img-responsive center-block"
                src={client.img}
                alt={client.client}
          />
            </div>
              <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                <h3 style={{ fontSize: 20.5 }} className="media-heading">{client.client}</h3>
                  <blockquote>
                    <footer>{client.location}</footer>
                  </blockquote>
              </div>
          </div>
        </div>
      )
      )
      clients[i]=items
    }
    return clients
  }

  get renderItem () {
    return (
      <Carousel style={{ height: '100%', width: '100%' }} controls interval={2000}>
        {this.splitClientsData.map((item, index) => (
          <Carousel.Item key={index} >
            {item}
          </Carousel.Item>
              )
            )
          }
      </Carousel>

    )
  }

  render () {
    return (
      <div id="clients" className="section translucent-bg bg-image-2 pb-clear">
        <div
          className="container-fluid "
          data-animation-effect="fadeIn"
          style={{ marginTop: '4.5%' }}
        >
          <h1 className="title text-center"><b>Clients</b></h1>
            <div className="space" />
              <div className="row">
                <div id="a-slider" className="da-slider">
                  {this.renderItem}
                </div>
              </div>
        </div>
      </div>
    )
  }
}

export default Clients



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/clients/index.js